import apiService from "./api";

const importService = {
  // Import users in chunks
  importUsersChunk(users, companyId) {
    return apiService.post('/import/users/chunk', {
      users,
      company: companyId,
    });
  },
  // Import all users at once
  importUsers(users, companyId) {
    return apiService.post('/import/users', {
      users,
      company: companyId,
    });
  },
};

export default importService;
